var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "app-container",
        staticStyle: { height: "calc(100vh - 130px)", "overflow-y": "auto" },
      },
      [
        _c(
          "el-form",
          {
            ref: "form",
            attrs: {
              model: _vm.queryForm,
              size: "small",
              "label-position": _vm.$i18n.locale !== "zh" ? "top" : "right",
              "label-width": _vm.$i18n.locale !== "zh" ? "auto" : "160px",
            },
          },
          [
            _c(
              "el-row",
              { attrs: { gutter: 20 } },
              [
                _c("el-col", { attrs: { span: 24 } }, [
                  _c(
                    "div",
                    { staticClass: "grid-content bg-purple" },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("basicData.businessPrincipal"),
                          },
                        },
                        [
                          _c("QueryProviderCmp", {
                            attrs: { val: _vm.queryForm.providerId },
                            on: {
                              change: function (val) {
                                return (_vm.queryForm.providerId = val)
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
                _c("el-col", { attrs: { span: 24 } }, [
                  _c(
                    "div",
                    { staticClass: "grid-content bg-purple" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("basicData.Outlets") } },
                        [
                          _c("QuerySiteCmp", {
                            attrs: {
                              val: _vm.queryForm.siteId,
                              "provider-id": _vm.queryForm.providerId,
                            },
                            on: {
                              change: function (val) {
                                return (_vm.queryForm.siteId = val)
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
                _c("el-col", { attrs: { span: 24 } }, [
                  _c(
                    "div",
                    { staticClass: "grid-content bg-purple" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("basicData.CustomerName") } },
                        [
                          _c("QueryCustomerCmp", {
                            attrs: {
                              val: _vm.queryForm.customerIdList,
                              multiple: true,
                            },
                            on: {
                              change: function (val) {
                                return (_vm.queryForm.customerIdList = val)
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
                _c("el-col", { attrs: { span: 24 } }, [
                  _c(
                    "div",
                    { staticClass: "grid-content bg-purple" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("basicData.CustomerCode") } },
                        [
                          _c("QueryCustomerCodeCmp", {
                            attrs: { val: _vm.queryForm.customerCodeId },
                            on: {
                              change: function (val) {
                                return (_vm.queryForm.customerCodeId = val)
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
                _c(
                  "el-col",
                  { attrs: { span: 24 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("collectionCenter.CommercialOwner"),
                        },
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            placeholder: _vm.$t("GlobalSetObj.pleaseInput"),
                            clearable: "",
                          },
                          model: {
                            value: _vm.queryForm.merchantName,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryForm, "merchantName", $$v)
                            },
                            expression: "queryForm.merchantName",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c("el-col", { attrs: { span: 24 } }, [
                  _c(
                    "div",
                    { staticClass: "grid-content bg-purple" },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "template",
                            { slot: "label" },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    placeholder: _vm.$t(
                                      "operationCenter.PleaseSelect"
                                    ),
                                  },
                                  model: {
                                    value: _vm.queryForm.timeField,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.queryForm, "timeField", $$v)
                                    },
                                    expression: "queryForm.timeField",
                                  },
                                },
                                [
                                  _c("el-option", {
                                    attrs: {
                                      label: _vm.$t("basicData.BusinessTime"),
                                      value: "operate_time",
                                    },
                                  }),
                                  _c("el-option", {
                                    attrs: {
                                      label: _vm.$t("newOrder.clientExitTime"),
                                      value: "customer_send_time",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              "default-time": ["00:00:00", "23:59:59"],
                              "end-placeholder": _vm.$t(
                                "operationCenter.endDate"
                              ),
                              "picker-options": _vm.dateLimit,
                              "range-separator": _vm.$t("operationCenter.to"),
                              "start-placeholder": _vm.$t(
                                "operationCenter.startDate"
                              ),
                              type: "datetimerange",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                            },
                            model: {
                              value: _vm.queryDate,
                              callback: function ($$v) {
                                _vm.queryDate = $$v
                              },
                              expression: "queryDate",
                            },
                          }),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ]),
                _c("el-col", { attrs: { span: 24 } }, [
                  _c(
                    "div",
                    { staticClass: "grid-content bg-purple" },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "template",
                            { slot: "label" },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    placeholder: _vm.$t(
                                      "operationCenter.PleaseSelect"
                                    ),
                                  },
                                  model: {
                                    value: _vm.queryForm.numberField,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.queryForm,
                                        "numberField",
                                        $$v
                                      )
                                    },
                                    expression: "queryForm.numberField",
                                  },
                                },
                                [
                                  _c("el-option", {
                                    attrs: {
                                      label: _vm.$t(
                                        "receivablePayable.TicketNumber"
                                      ),
                                      value: "waybill_number",
                                    },
                                  }),
                                  _c("el-option", {
                                    attrs: {
                                      label: _vm.$t(
                                        "receivablePayable.CustomerTrackingNumber"
                                      ),
                                      value: "customer_number",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c("el-input", {
                            attrs: {
                              placeholder: _vm
                                .$t("newOrder.PreciseSearch")
                                .replace("200", _vm.NUMBERLIST_MAX_LENGTH + ""),
                              rows: 4,
                              type: "textarea",
                            },
                            model: {
                              value: _vm.numberList,
                              callback: function ($$v) {
                                _vm.numberList = $$v
                              },
                              expression: "numberList",
                            },
                          }),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ]),
                _c("el-col", { attrs: { span: 24 } }, [
                  _c(
                    "div",
                    { staticClass: "grid-content bg-purple" },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "receivablePayable.WhetherItHasBeenPaid"
                            ),
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "operationCenter.PleaseSelect"
                                ),
                                clearable: "",
                                filterable: "",
                              },
                              model: {
                                value: _vm.queryForm.isAccept,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryForm, "isAccept", $$v)
                                },
                                expression: "queryForm.isAccept",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("basicData.all"),
                                  value: null,
                                },
                              }),
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("receivablePayable.Paid"),
                                  value: true,
                                },
                              }),
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("receivablePayable.NonPayment"),
                                  value: false,
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
                _c("el-col", { attrs: { span: 24 } }, [
                  _c(
                    "div",
                    { staticClass: "grid-content bg-purple" },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("receivablePayable.billType"),
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "operationCenter.PleaseSelect"
                                ),
                                clearable: "",
                                filterable: "",
                              },
                              model: {
                                value: _vm.queryForm.billType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryForm, "billType", $$v)
                                },
                                expression: "queryForm.billType",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("basicData.all"),
                                  value: null,
                                },
                              }),
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("receivablePayable.forward"),
                                  value: 0,
                                },
                              }),
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("receivablePayable.reverse"),
                                  value: 1,
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
                _c("el-col", { attrs: { span: 24 } }, [
                  _c(
                    "div",
                    { staticClass: "grid-content bg-purple" },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("ClaimsManagement.PaymentMethod"),
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "operationCenter.PleaseSelect"
                                ),
                                clearable: "",
                                filterable: "",
                              },
                              model: {
                                value: _vm.queryForm.payType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryForm, "payType", $$v)
                                },
                                expression: "queryForm.payType",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("basicData.all"),
                                  value: null,
                                },
                              }),
                              _c("el-option", {
                                attrs: { value: 0, label: "OnLine" },
                              }),
                              _c("el-option", {
                                attrs: { value: 1, label: "OffLine" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
                _c("el-col", { attrs: { span: 24 } }, [
                  _c(
                    "div",
                    { staticClass: "grid-content bg-purple" },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "receivablePayable.WhetherToGenerateAStatement"
                            ),
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "operationCenter.PleaseSelect"
                                ),
                                clearable: "",
                                filterable: "",
                              },
                              model: {
                                value: _vm.queryForm.isGenBill,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryForm, "isGenBill", $$v)
                                },
                                expression: "queryForm.isGenBill",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("basicData.all"),
                                  value: null,
                                },
                              }),
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("receivablePayable.Generated"),
                                  value: true,
                                },
                              }),
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t(
                                    "receivablePayable.NotGenerated"
                                  ),
                                  value: false,
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
                _c("el-col", { attrs: { span: 24 } }, [
                  _c(
                    "div",
                    { staticClass: "grid-content bg-purple" },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("collectionCenter.businessT"),
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "operationCenter.PleaseSelect"
                                ),
                                clearable: "",
                                filterable: "",
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.changeBusinessType(
                                    _vm.queryForm.businessType
                                  )
                                },
                              },
                              model: {
                                value: _vm.queryForm.businessType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryForm, "businessType", $$v)
                                },
                                expression: "queryForm.businessType",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("basicData.all"),
                                  value: null,
                                },
                              }),
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("collectionCenter.lanshou"),
                                  value: 1,
                                },
                              }),
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t(
                                    "collectionCenter.expressDelivery"
                                  ),
                                  value: 0,
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
                _c("el-col", { attrs: { span: 24 } }, [
                  _c(
                    "div",
                    { staticClass: "grid-content bg-purple" },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("collectionCenter.lanshouTypee"),
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "operationCenter.PleaseSelect"
                                ),
                                clearable: "",
                                filterable: "",
                              },
                              model: {
                                value: _vm.queryForm.collectType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryForm, "collectType", $$v)
                                },
                                expression: "queryForm.collectType",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("basicData.all"),
                                  value: null,
                                },
                              }),
                              _vm._l(_vm.COLLECT_TYPE, function (item) {
                                return _c("el-option", {
                                  key: item.value,
                                  attrs: {
                                    label: item.label,
                                    value: item.value,
                                  },
                                })
                              }),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
                _c("el-col", { attrs: { span: 24 } }, [
                  _c(
                    "div",
                    { staticClass: "grid-content bg-purple" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("newOrder.CollectionType") } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                disabled: _vm.queryForm.businessType !== 1,
                                placeholder: _vm.$t(
                                  "operationCenter.PleaseSelect"
                                ),
                                clearable: "",
                                filterable: "",
                              },
                              on: { change: _vm.changePush },
                              model: {
                                value: _vm.queryForm.collectionCategory,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.queryForm,
                                    "collectionCategory",
                                    $$v
                                  )
                                },
                                expression: "queryForm.collectionCategory",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("basicData.all"),
                                  value: null,
                                },
                              }),
                              _vm._l(
                                _vm.COLLECTION_CATEGORY_TYPE,
                                function (item) {
                                  return _c("el-option", {
                                    key: item.value,
                                    attrs: {
                                      label: item.label,
                                      value: item.value,
                                    },
                                  })
                                }
                              ),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
                _c("el-col", { attrs: { span: 24 } }, [
                  _c(
                    "div",
                    { staticClass: "grid-content bg-purple" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("basicData.明细业务类型") } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "operationCenter.PleaseSelect"
                                ),
                                clearable: "",
                                filterable: "",
                              },
                              model: {
                                value: _vm.queryForm.subBusinessType,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.queryForm,
                                    "subBusinessType",
                                    $$v
                                  )
                                },
                                expression: "queryForm.subBusinessType",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("basicData.all"),
                                  value: null,
                                },
                              }),
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t(
                                    "basicData.CollectionSystemBusiness"
                                  ),
                                  value: 1,
                                },
                              }),
                              _c("el-option", {
                                attrs: {
                                  label:
                                    "" +
                                    _vm.$t("basicData.CourierSystemBusiness"),
                                  value: 0,
                                },
                              }),
                              _c("el-option", {
                                attrs: {
                                  label:
                                    "" + _vm.$t("collectionCenter.dispatch"),
                                  value: 2,
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
                _c("el-col", { attrs: { span: 24 } }, [
                  _c(
                    "div",
                    { staticClass: "grid-content bg-purple" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("placeOrder.cargoType") } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "operationCenter.PleaseSelect"
                                ),
                                clearable: "",
                                filterable: "",
                              },
                              model: {
                                value: _vm.queryForm.cargoType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryForm, "cargoType", $$v)
                                },
                                expression: "queryForm.cargoType",
                              },
                            },
                            _vm._l(_vm.CARGO_TYPE, function (item, ind) {
                              return _c("el-option", {
                                key: ind,
                                attrs: { label: item.label, value: item.value },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
                _c("el-col", { attrs: { span: 24 } }, [
                  _c(
                    "div",
                    { staticClass: "grid-content bg-purple" },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("GlobalSetObj.serviceTypes") },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "operationCenter.PleaseSelect"
                                ),
                                clearable: "",
                                filterable: "",
                              },
                              model: {
                                value: _vm.queryForm.expressType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryForm, "expressType", $$v)
                                },
                                expression: "queryForm.expressType",
                              },
                            },
                            _vm._l(_vm.EXPRESS_TYPE, function (item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.name, value: item.value },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
                _vm.selectKey === 1
                  ? _c("el-col", { attrs: { span: 24 } }, [
                      _c(
                        "div",
                        { staticClass: "grid-content bg-purple" },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("basicData.BatchNo"),
                                prop: "billBatchNumber",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: { disabled: _vm.isReadOnly },
                                model: {
                                  value: _vm.queryForm.billBatchNumber,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.queryForm,
                                      "billBatchNumber",
                                      $$v
                                    )
                                  },
                                  expression: "queryForm.billBatchNumber",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ])
                  : _vm._e(),
                _vm.selectKey === 2
                  ? _c("el-col", { attrs: { span: 24 } }, [
                      _c(
                        "div",
                        { staticClass: "grid-content bg-purple" },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("basicData.ReceiptNumber"),
                                prop: "receiptNumber",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: { disabled: _vm.isReadOnly },
                                model: {
                                  value: _vm.queryForm.receiptNumber,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.queryForm,
                                      "receiptNumber",
                                      $$v
                                    )
                                  },
                                  expression: "queryForm.receiptNumber",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ])
                  : _vm._e(),
                _c("el-col", { attrs: { span: 24 } }, [
                  _c(
                    "div",
                    { staticClass: "grid-content bg-purple" },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("basicData.ExpenseType"),
                            prop: "feeName",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "operationCenter.PleaseSelect"
                                ),
                                clearable: "",
                                filterable: "",
                              },
                              model: {
                                value: _vm.queryForm.feeCode,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryForm, "feeCode", $$v)
                                },
                                expression: "queryForm.feeCode",
                              },
                            },
                            _vm._l(_vm.feeList, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: {
                                  label: item.displayName,
                                  value: item.code,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
                _c("el-col", { attrs: { span: 24 } }, [
                  _c(
                    "div",
                    { staticClass: "grid-content bg-purple" },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("collectionCenter.OrderStatus"),
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "operationCenter.PleaseSelect"
                                ),
                                clearable: "",
                                filterable: "",
                              },
                              model: {
                                value: _vm.queryForm.status,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryForm, "status", $$v)
                                },
                                expression: "queryForm.status",
                              },
                            },
                            _vm._l(_vm.orderStatusList, function (item, ind) {
                              return _c("el-option", {
                                key: ind,
                                attrs: {
                                  label: item.label || item.collectStatusName,
                                  value: item.code || item.collectStatus,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
                _c(
                  "el-col",
                  { attrs: { span: 24 } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("basicData.Handler") } },
                      [
                        _c("AgentCmp", {
                          attrs: {
                            disabled: _vm.isJurisdiction,
                            val: _vm.queryForm.handlerId,
                          },
                          on: { change: _vm.agentChange },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 24 } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("newOrder.RecipientState") } },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "100%" },
                            attrs: {
                              placeholder: _vm.$t("placeOrder.pleaseChoose"),
                              clearable: "",
                              filterable: "",
                            },
                            model: {
                              value: _vm.queryForm.receiveState,
                              callback: function ($$v) {
                                _vm.$set(_vm.queryForm, "receiveState", $$v)
                              },
                              expression: "queryForm.receiveState",
                            },
                          },
                          _vm._l(_vm.stateList, function (item) {
                            return _c("el-option", {
                              key: item.id,
                              attrs: {
                                label: item.shortName,
                                value: item.shortName,
                              },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 24 } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("newOrder.SenderState") } },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "100%" },
                            attrs: {
                              placeholder: _vm.$t("placeOrder.pleaseChoose"),
                              clearable: "",
                              filterable: "",
                            },
                            model: {
                              value: _vm.queryForm.senderState,
                              callback: function ($$v) {
                                _vm.$set(_vm.queryForm, "senderState", $$v)
                              },
                              expression: "queryForm.senderState",
                            },
                          },
                          _vm._l(_vm.stateList, function (item) {
                            return _c("el-option", {
                              key: item.id,
                              attrs: {
                                label: item.shortName,
                                value: item.shortName,
                              },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 24 } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("CenterForSorting.channel") } },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "100%" },
                            attrs: {
                              placeholder: _vm.$t(
                                "operationCenter.PleaseSelect"
                              ),
                              clearable: "",
                            },
                            model: {
                              value: _vm.queryForm.channelValue,
                              callback: function ($$v) {
                                _vm.$set(_vm.queryForm, "channelValue", $$v)
                              },
                              expression: "queryForm.channelValue",
                            },
                          },
                          _vm._l(_vm.channelList, function (item, ind) {
                            return _c("el-option", {
                              key: ind,
                              attrs: {
                                label:
                                  "" +
                                  item.dictName +
                                  "(" +
                                  item.dictValue +
                                  ")",
                                value: item.dictValue,
                              },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      {
        staticStyle: {
          "text-align": "center",
          "border-top": "1px solid #ccc",
          "padding-top": "10px",
        },
      },
      [
        _c(
          "el-button",
          {
            attrs: { size: "small", type: "primary" },
            on: { click: _vm.searchForm },
          },
          [_vm._v(_vm._s(_vm.$t("basicData.Search")))]
        ),
        _c(
          "el-button",
          {
            attrs: { size: "small", type: "success" },
            on: { click: _vm.onReset },
          },
          [_vm._v(_vm._s(_vm.$t("basicData.reset")))]
        ),
        _c(
          "el-button",
          { attrs: { size: "small" }, on: { click: _vm.onClose } },
          [_vm._v(_vm._s(_vm.$t("basicData.Cancel")))]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }